import CloseIcon from "@mui/icons-material/Close";
import Button from "@mui/material/Button";
import { useDispatch, useSelector } from "react-redux";
import { userSlice } from "../redux/user/userSlice";
import {
  deleteGame,
  getGamesData,
  deleteAccaunt,
  saveGame,
} from "../redux/asyncThunk/userActions";
import { stripSchemeTransient, FIRST_SCENE_GROUP_ID } from "./nodes/schemeLayout";
import { useNavigate } from "react-router-dom";
import NewGame from "./NewGame";

const { closeDialog } = userSlice;

export default function Dialog() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const selectedGameId = useSelector((state) => state.user?.selectedGameId);
  const game = useSelector((state) => state.user?.game);
  const user = useSelector((state) => state.user?.data?.user);
  const { type, data: dialogData } = useSelector((state) => state.user?.showDialog);

  const handleDeleteScene = () => {
    const groupId = dialogData?.groupId;
    if (!groupId || !game?.nodes || groupId === FIRST_SCENE_GROUP_ID) return;

    const deleteIds = new Set([groupId]);
    game.nodes.forEach((node) => {
      if (node.parentId === groupId) deleteIds.add(node.id);
    });

    const updateNodes = game.nodes.filter((node) => !deleteIds.has(node.id));
    const updateEdges =
      game.edges?.filter(
        (edge) => !deleteIds.has(edge.source) && !deleteIds.has(edge.target)
      ) ?? [];

    dispatch(
      saveGame({
        selectedGameId: game._id,
        nodes: stripSchemeTransient(updateNodes),
        edges: updateEdges,
      })
    );
    dispatch(closeDialog());
  };

  const switchCase = (dialogType) => {
    switch (dialogType) {
      case "new":
        return <NewGame />;
      case "delete":
        return (
          <div className="app-dialog__body">
            <div className="app-dialog__title">Подтвердите удаление</div>
            <p>Вы хотите удалить проект «{game?.title}».</p>
            <p>Будут удалены все файлы без возможности отмены.</p>
            <div className="app-dialog__actions">
              <Button onClick={() => dispatch(closeDialog())} size="small">
                Отменить
              </Button>
              <Button
                color="error"
                size="small"
                variant="contained"
                onClick={() => {
                  const onSucces = () => {
                    dispatch(getGamesData({ id: user.id }));
                    navigate("/main", { replace: true });
                  };
                  dispatch(
                    deleteGame({
                      userId: user.id,
                      id: selectedGameId,
                      onSucces,
                    })
                  );
                }}
              >
                Удалить
              </Button>
            </div>
          </div>
        );
      case "delete-scene":
        return (
          <div className="app-dialog__body">
            <div className="app-dialog__title">Удалить сцену?</div>
            <p>Будут удалены все кнопки и связи этой сцены.</p>
            <div className="app-dialog__actions app-dialog__actions--wide">
              <Button onClick={() => dispatch(closeDialog())} size="small">
                Отменить
              </Button>
              <Button
                color="error"
                size="small"
                variant="contained"
                onClick={handleDeleteScene}
              >
                Удалить
              </Button>
            </div>
          </div>
        );
      case "delete-accaunt":
        return (
          <div className="app-dialog__body">
            <div className="app-dialog__title">Подтвердите удаление</div>
            <p>Вы хотите удалить аккаунт.</p>
            <p>
              Мы удалим ваш аккаунт, все созданные проекты и загруженные файлы.
            </p>
            <div className="app-dialog__actions">
              <Button onClick={() => dispatch(closeDialog())} size="small">
                Отменить
              </Button>
              <Button
                color="error"
                size="small"
                variant="contained"
                onClick={() => {
                  const onSucces = () => {
                    navigate("/", { replace: true });
                  };
                  dispatch(
                    deleteAccaunt({
                      userId: user.id,
                      onSucces,
                    })
                  );
                }}
              >
                Удалить
              </Button>
            </div>
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div
      className="app-dialog-backdrop"
      onClick={() => dispatch(closeDialog())}
      role="presentation"
    >
      <div
        className="app-dialog"
        onClick={(event) => event.stopPropagation()}
        role="dialog"
      >
        <div className="app-dialog__close">
          <CloseIcon onClick={() => dispatch(closeDialog())} />
        </div>
        {switchCase(type)}
      </div>
    </div>
  );
}
